import React from 'react'
import ToDoItem from "./TodoItem";

function TodoList({todos, deleteTodo, toggleComplete, editTodo}) {
  return (
    <div className='TodoList'>
      {todos.map(todo => (
        <ToDoItem 
            key={todo.id}
            todo={todo}
            deleteTodo={deleteTodo}
            toggleComplete = {toggleComplete}
            editTodo = {editTodo}

        />
      ))}
    </div>
  )
}

export default TodoList
